import React from "react";
import videoc from "../../assets/video/tv-box.mp4";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Question() {

    return (
        <>
            <section className="container px-5 py-20">
                <div className="text-center mb-10"><h4
                    className="text-[32px] md:text-[35px] leading-[1.1em] font-medium uppercase mb-0">Preguntas
                    frecuentes</h4>
                    <div className="mt-5 flex items-center gap-[5px] w-max mx-auto text-white">
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-10 h-1 rounded-xs"></div>
                    </div>
                    <p className="mt-4 mx-auto leading-relaxed text-white">Seguramente tiene algunas dudas sobre el
                        funcionamiento de Stella TV en una pc o laptop. Aquí respondemos algunas dudas comunes.</p>
                </div>
                <div className="mt-16 grid md:grid-cols-2 gap-[30px] px-[15px]">
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        descargar Stella en Windows o Mac?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">La única forma de descargar e instalar esta aplicación en
                                una computadora o laptop es mediante emuladores de Android. Así, podrás disfrutar
                                plenamente de la app y su contenido.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Error
                        de STELLATV en mi pc?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Si la imagen no se visualiza correctamente o presenta
                                algún otro problema en el emulador, te recomendamos desinstalarlo e instalar un emulador
                                diferente para probar su funcionamiento en tu computadora.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Qué
                        emulador Android recomiendan?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Recomendamos instalar dos emuladores, cualquiera de los
                                cuales puedes usar: el primero es BlueStacks y el segundo es Nox Player. Ambos son
                                compatibles con Windows y macOS.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        ver Stella TV cin VLC Player?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Actualmente, las listas IPTV de Stella TV no están
                                operativas y, por lo tanto, no pueden reproducirse en ningún reproductor IPTV. Una vez
                                que vuelvan a estar disponibles, funcionarán sin problemas.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        instalar Stella TV sin emuladores?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">No es posible. Para ver todo el contenido de la
                                aplicación Magis TV en una computadora, la única opción es utilizar los programas
                                mencionados anteriormente.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        comprar Stella TV para PC?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Visita nuestro sitio web y dirígete a la sección de
                                planes, donde encontrarás toda la información sobre precios para elegir el que mejor se
                                adapte a tus necesidades. ¡Contamos con nuevas ofertas!</p></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Question;
